import { RowspageBlock as RowsBlockTypes } from "@/payload-types";
import { Fragment } from "react";
import { ContentBlock } from "./ContentBlock";
import { GalleryBlock } from "./GalleryBlock";
import { MediaBlock } from "@onclicks/sharedcomponents/defaultTheme/blocks/MediaBlock";
import { CallToActionBlock } from "./CallToActionBlock";
import { CategoryMenuBlock } from "./CategoryMenu";
import { ArchiveBlock } from "./ArchiveBlock";

const blockComponents = {
  gallery: GalleryBlock,
  content: ContentBlock,
  mediaBlock: MediaBlock,
  cta: CallToActionBlock,
  categoryMenu: CategoryMenuBlock,
  archiveBlock: ArchiveBlock,
};

const RowsLayoutBlock: React.FC<RowsBlockTypes> = (props) => {
  const { content } = props;

  const hasBlocks = content && Array.isArray(content) && content.length > 0;

  if (!hasBlocks) return null;

  if (hasBlocks) {
    return (
      <Fragment>
        <div className="w-full bg-linear-to-b from-[#2A2D3F] to-[#000000] text-white py-7">
          {content.map((block, index) => {
            if (block) {
              const { blockType } = block;

              if (blockType && blockType in blockComponents) {
                const Block =
                  blockComponents[blockType as keyof typeof blockComponents];

                if (Block) {
                  return (
                    <div key={index}>
                      <div>
                        <Block {...block} disableInnerContainer />
                      </div>
                    </div>
                  );
                }
              }
            }
            return null;
          })}
        </div>
      </Fragment>
    );
  }
};

export { RowsLayoutBlock };
